export enum ContextMenuTypes {
  DeleteDialog,
  LeaveGroup,
  ViewAllParticipants,
  ViewProfile,
  FollowUser,
  UnfollowUser,
}
